import SubserviceWrapper from "../../../components/Subservice/SubserviceWrapper";
import services from "../../../service.map";

import "./styles/boc.styles.css";

export const BOC = () => {
	return <SubserviceWrapper config={services.boc} />;
};
